module.exports = __webpack_public_path__ + "img/3.382b2501.webp";